import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const createCheckoutSession = async (items) => {
  const { data } = await api.post("/checkout/session", {
    items: items.map((i) => ({ id: i.id, quantity: i.quantity, mode: i.mode || "once" })),
    origin_url: window.location.origin,
  });
  return data;
};

export const getCheckoutStatus = async (sessionId) => {
  const { data } = await api.get(`/checkout/status/${sessionId}`);
  return data;
};

export const subscribeNewsletter = async (email) => {
  const { data } = await api.post("/newsletter", { email });
  return data;
};
